<template>
  <div>
    <Chats/>
  </div>

</template>
<script>
  import Chats from '../messenger/Chats.vue'
  export default {
    data () {
      return {
        tab: null,
      }
    },
    components: {
      Chats
    }
  }
</script>
